module.exports = __webpack_public_path__ + "static/media/reachcustomermain.d6bc0c59.png";